module.exports = __webpack_public_path__ + "img/serrote de poda.a736b2e9.webp";